import { useState } from "react";
import api from "../../services/api";
import Swal from "sweetalert2";

export default function InvoiceRow({ invoice, onReprint }) {
  const [downloading, setDownloading] = useState(false);

  const handleDownloadPdf = async () => {
    setDownloading(true);
    try {
      const response = await api.get(`/invoices/${invoice.id}/pdf`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoice.invoice_number}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Could not download the PDF", "error");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <tr>
      <td>
        <span className="badge badge-primary">
          {invoice.invoice_number ?? "N/A"}
        </span>
      </td>

      <td>{invoice.sale?.client?.nombre ?? "Walk-in"}</td>

      <td>
        {invoice.fecha_emision
          ? new Date(invoice.fecha_emision).toLocaleDateString("en-US", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            })
          : "—"}
      </td>

      <td>
        {invoice.sale?.monto_final != null
          ? `$${Number(invoice.sale.monto_final).toFixed(2)}`
          : "—"}
      </td>

      <td style={{ textAlign: 'center' }}>
        {invoice.pdf_path ? (
          <button
            className="btn btn-success btn-sm"
            onClick={handleDownloadPdf}
            disabled={downloading}
          >
            {downloading ? "..." : "PDF"}
          </button>
        ) : (
          <span className="badge badge-secondary">Not available</span>
        )}
      </td>

      <td style={{ textAlign: 'center' }}>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => onReprint(invoice)}
          title="Reprint receipt"
        >
          Reprint
        </button>
      </td>
    </tr>
  );
}